import get from 'lodash/get';
import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { NEWS_BASE_URL } from 'services/news/configs';
import { fetcher, swrImmutableConfigs } from 'services/utils';
import useSWR, { useSWRConfig } from 'swr';

import { DEFAULT_RECORDS_PER_PAGE_VALUE, PAGE_QUERY_STRING_KEY, RECORD_PER_PAGE_QUERY_STRING_KEY } from '@app/common/helpers';

const useGenerateNewsApiEndpoint = () => {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const apiSearchParams = new URLSearchParams();

    const currentPage = Number(searchParams.get(PAGE_QUERY_STRING_KEY) || 1);

    apiSearchParams.set('page', String(currentPage));

    const recordPerPage = Number(searchParams.get(RECORD_PER_PAGE_QUERY_STRING_KEY) || DEFAULT_RECORDS_PER_PAGE_VALUE);

    apiSearchParams.set('limit', String(recordPerPage));

    return `${NEWS_BASE_URL}/get-all-news?${apiSearchParams.toString()}`;
  }, [searchParams]);
};

export const useMutateCaseNews = () => {
  const apiEndpoint = useGenerateNewsApiEndpoint();
  const { mutate } = useSWRConfig();

  return useCallback(() => mutate(apiEndpoint), [mutate, apiEndpoint]);
};

const useGetAllNews = (isImmutable = false) => {
  const apiEndpoint = useGenerateNewsApiEndpoint();
  const { data, isValidating, error, mutate } = useSWR(apiEndpoint, fetcher, swrImmutableConfigs(isImmutable));

  return {
    data: get(data, 'data.newsList', []),
    pagination: get(data, 'data.pagination', null),
    isLoading: isValidating,
    mutate,
    errorMessage: error
  };
};

export default useGetAllNews;
